<template>
  <p>dashboard</p>
</template>

<script>
export default {
  data: () => ({})
}
</script>
